import React, { useEffect, useState } from 'react'
import { QuantityWrapper } from './styled'

function Quantity({ defaultValue, handleChangeInput, id, maxValue, minValue }) {
    const [quantity, setQuantity] = useState(defaultValue)
    useEffect(() => {
        setQuantity(defaultValue)
    }, [defaultValue])
    const handlePlus = () => {
        if (maxValue) {
            if (quantity < maxValue) {
                setQuantity(quantity + 1)
                handleChangeInput(quantity + 1, id)
            }

        }
    }
    const handleMinus = () => {
        if (quantity > minValue) {
            setQuantity(quantity - 1)
            handleChangeInput(quantity - 1, id)
        }
    }

    return (
        <QuantityWrapper>
            <div className='quantity'>
                <ul className='quantity_list'>
                    <li className='quantity_list_item'>
                        <div className='quantity_list_item_control bg-white clickable' onClick={handleMinus}>
                            <i className='ti-minus text-black s-18 bold'></i>
                        </div>
                    </li>
                    <li className='quantity_list_item'>
                        <div>
                            <input value={quantity} min={0} readOnly={true}
                            />
                        </div>
                    </li>
                    <li className='quantity_list_item'>
                        <div className='quantity_list_item_control bg-white clickable' onClick={handlePlus}>
                            <i className='ti-plus text-black s-18 bold'></i>
                        </div>
                    </li>
                </ul>
            </div>
        </QuantityWrapper>
    )
}
export default Quantity